/**
 * The git graphs the server pushed (`{t:"gitGraph"}`, server/graphPush.ts), by
 * repo, as the board socket delivered them (admins only). The git panel applies
 * its repo's straight into what it shows, rather than reading it again.
 * Module-level, like lib/gitPushes.ts: the socket lives in the board store, the
 * panel only while the tmux view is open.
 */
import { shallowRef } from "vue";
import type { GitGraph } from "@shared/gitGraph.js";

/** The latest pushed graph of each repo, replaced whole on each push. */
export const gitGraphs = shallowRef<ReadonlyMap<string, GitGraph>>(new Map());

export function gitGraphPushed(repo: string, graph: GitGraph): void {
  const next = new Map(gitGraphs.value);
  next.set(repo, graph);
  gitGraphs.value = next;
}
